import { Attrs, EventListeners, MinzeElement, Reactive } from 'minze'

export class LvcLinkButton extends MinzeElement {
  attrs: Attrs = [['href', '#']]
  reactive: Reactive = ['isHovered']
  html = () => `
    <a href="${this.href}">
      <slot></slot>
    </a>
  `
  css = () => `
    a {
      height: 50px;
      padding: 0 25px;
      border-radius: 30px;
      background: ${this.isHovered ? 'linear-gradient(131.14deg, #1E007D 19.64%, #000FE3 94.07%)' : '#1E007D'};
      font-size: 14px;
      font-family: inherit;
      font-weight: 500;
      color: #fff;
      text-decoration: none;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1.1;
    }
  `
  eventListeners: EventListeners = [
    [this, 'mouseover', e => (this.isHovered = true)],
    [this, 'mouseout', e => (this.isHovered = false)],
  ]
}
